(() => {
  'use strict';

  const ROOT_SELECTOR =
    '.jdgm-carousel-wrapper';

  const WAIT_INTERVAL =
    250;

  const WAIT_TIMEOUT =
    6000;

  const MAX_MOBILE_DOTS =
    5;


  /* =========================================================
     TRANSLATE X DE JUDGE.ME
     ========================================================= */

  function getTranslateX(element) {

    const transform =
      window
        .getComputedStyle(element)
        .transform;


    if (
      !transform ||
      transform === 'none'
    ) {
      return 0;
    }


    try {

      return new DOMMatrixReadOnly(
        transform
      ).m41;

    } catch (error) {

      const match =
        transform.match(
          /matrix.*\((.+)\)/
        );


      if (!match) {
        return 0;
      }


      const values =
        match[1]
          .split(',')
          .map(Number);


      return values.length === 6
        ? values[4]
        : values[12] || 0;
    }

  }


  /* =========================================================
     INICIALIZAR
     ========================================================= */

  function initCarousel(root) {

    if (
      !root ||
      root.dataset.ptCarouselReady === 'true'
    ) {
      return true;
    }


    const carousel =
      root.querySelector(
        '.jdgm-carousel'
      );


    const viewport =
      root.querySelector(
        '.jdgm-carousel__item-container'
      );


    const track =
      root.querySelector(
        '.jdgm-carousel__item-wrapper'
      );


    const items =
      Array.from(
        root.querySelectorAll(
          '.jdgm-carousel-item'
        )
      );


    const previousButton =
      root.querySelector(
        '.jdgm-carousel__left-arrow'
      );


    const nextButton =
      root.querySelector(
        '.jdgm-carousel__right-arrow'
      );


    /*
      Judge.me todavía puede estar construyendo
      el widget.
    */

    if (
      !carousel ||
      !viewport ||
      !track ||
      !items.length ||
      !previousButton ||
      !nextButton
    ) {
      return false;
    }


    root.dataset.ptCarouselReady =
      'true';


    /* =======================================================
       FLECHAS ORIGINALES
       ======================================================= */

    previousButton.setAttribute(
      'tabindex',
      '-1'
    );

    previousButton.setAttribute(
      'aria-hidden',
      'true'
    );


    nextButton.setAttribute(
      'tabindex',
      '-1'
    );

    nextButton.setAttribute(
      'aria-hidden',
      'true'
    );


    /* =======================================================
       DOTS
       ======================================================= */

    const dotsContainer =
      document.createElement(
        'div'
      );


    dotsContainer.className =
      'pt-jdgm-dots';


    dotsContainer.setAttribute(
      'role',
      'group'
    );


    dotsContainer.setAttribute(
      'aria-label',
      'Navegación de opiniones'
    );


    carousel.appendChild(
      dotsContainer
    );


    let visibleItems = 1;
    let totalPages = 1;
    let currentPage = 0;

    let dots = [];


    /* =======================================================
       MÉTRICAS
       ======================================================= */

    function getMetrics() {

      const firstItem =
        items[0];


      if (!firstItem) {
        return null;
      }


      const itemWidth =
        firstItem
          .getBoundingClientRect()
          .width;


      const viewportWidth =
        viewport
          .getBoundingClientRect()
          .width;


      if (
        !itemWidth ||
        !viewportWidth
      ) {
        return null;
      }


      const visible =
        Math.max(
          1,
          Math.round(
            viewportWidth /
            itemWidth
          )
        );


      const pages =
        Math.max(
          1,
          Math.ceil(
            items.length /
            visible
          )
        );


      return {
        itemWidth,
        visible,
        pages
      };
    }


    /* =======================================================
       QUÉ DOTS MOSTRAMOS

       Escritorio:
       mostramos todos porque normalmente hay pocos.

       Móvil:
       máximo 5 visibles.

       Ejemplo:
       ○ ○ ● ○ ○

       Cuando avanzamos, la ventana se desplaza.
       ======================================================= */

    function updateDotVisibility() {

      const mobile =
        window.innerWidth <= 749;


      /*
        Escritorio o 5 puntos o menos:
        todos visibles.
      */

      if (
        !mobile ||
        dots.length <= MAX_MOBILE_DOTS
      ) {

        dots.forEach(
          (dot) => {

            dot.classList.add(
              'is-visible'
            );

          }
        );

        return;
      }


      const half =
        Math.floor(
          MAX_MOBILE_DOTS / 2
        );


      let start =
        currentPage - half;


      start =
        Math.max(
          0,
          Math.min(
            start,
            dots.length -
              MAX_MOBILE_DOTS
          )
        );


      const end =
        start +
        MAX_MOBILE_DOTS;


      dots.forEach(
        (dot, index) => {

          dot.classList.toggle(
            'is-visible',
            index >= start &&
            index < end
          );

        }
      );

    }


    /* =======================================================
       DOT ACTIVO
       ======================================================= */

    function setActiveDot(page) {

      if (!dots.length) {
        return;
      }


      const safePage =
        Math.max(
          0,
          Math.min(
            page,
            dots.length - 1
          )
        );


      currentPage =
        safePage;


      dots.forEach(
        (dot, index) => {

          const active =
            index === safePage;


          dot.classList.toggle(
            'is-active',
            active
          );


          if (active) {

            dot.setAttribute(
              'aria-current',
              'true'
            );

          } else {

            dot.removeAttribute(
              'aria-current'
            );

          }

        }
      );


      updateDotVisibility();

    }


    /* =======================================================
       LEER POSICIÓN ACTUAL DE JUDGE.ME
       ======================================================= */

    function updateFromTrack() {

      const metrics =
        getMetrics();


      if (!metrics) {
        return;
      }


      visibleItems =
        metrics.visible;

      totalPages =
        metrics.pages;


      const translateX =
        Math.abs(
          getTranslateX(track)
        );


      const itemIndex =
        Math.max(
          0,
          Math.round(
            translateX /
            metrics.itemWidth
          )
        );


      const page =
        Math.floor(
          itemIndex /
          visibleItems
        );


      setActiveDot(
        Math.min(
          page,
          totalPages - 1
        )
      );

    }


    /* =======================================================
       IR A PÁGINA

       Seguimos utilizando los controles internos
       originales de Judge.me.
       ======================================================= */

    function goToPage(targetPage) {

      updateFromTrack();


      const target =
        Math.max(
          0,
          Math.min(
            targetPage,
            totalPages - 1
          )
        );


      if (
        target === currentPage
      ) {
        return;
      }


      const difference =
        target - currentPage;


      const control =
        difference > 0
          ? nextButton
          : previousButton;


      const clicks =
        Math.abs(
          difference
        ) * visibleItems;


      let performed =
        0;


      function performClick() {

        control.click();

        performed += 1;


        if (
          performed < clicks
        ) {

          window.setTimeout(
            performClick,
            70
          );

        } else {

          window.setTimeout(
            updateFromTrack,
            160
          );

        }

      }


      performClick();

    }


    /* =======================================================
       CREAR DOTS
       ======================================================= */

    function renderDots() {

      const metrics =
        getMetrics();


      if (!metrics) {
        return;
      }


      visibleItems =
        metrics.visible;

      totalPages =
        metrics.pages;


      dotsContainer.replaceChildren();


      dots =
        [];


      for (
        let index = 0;
        index < totalPages;
        index += 1
      ) {

        const dot =
          document.createElement(
            'button'
          );


        dot.type =
          'button';


        dot.className =
          'pt-jdgm-dot';


        dot.setAttribute(
          'aria-label',
          `Ver grupo de opiniones ${index + 1}`
        );


        dot.addEventListener(
          'click',
          () => {

            goToPage(index);

          }
        );


        dotsContainer.appendChild(
          dot
        );


        dots.push(
          dot
        );

      }


      updateFromTrack();

    }


    /* =======================================================
       OBSERVAR ÚNICAMENTE EL TRACK

       Judge.me modifica su atributo style cuando
       desplaza las reseñas.
       ======================================================= */

    const trackObserver =
      new MutationObserver(
        () => {

          window.requestAnimationFrame(
            updateFromTrack
          );

        }
      );


    trackObserver.observe(
      track,
      {
        attributes: true,

        attributeFilter: [
          'style'
        ]
      }
    );


    /* =======================================================
       RESPONSIVE
       ======================================================= */

    if (
      'ResizeObserver' in window
    ) {

      let frame =
        null;


      const resizeObserver =
        new ResizeObserver(
          () => {

            if (frame) {

              window.cancelAnimationFrame(
                frame
              );

            }


            frame =
              window.requestAnimationFrame(
                renderDots
              );

          }
        );


      resizeObserver.observe(
        viewport
      );

    } else {

      let resizeTimer;


      window.addEventListener(
        'resize',
        () => {

          window.clearTimeout(
            resizeTimer
          );


          resizeTimer =
            window.setTimeout(
              renderDots,
              150
            );

        },
        {
          passive: true
        }
      );

    }


    window.requestAnimationFrame(
      renderDots
    );


    return true;

  }


  /* =========================================================
     INICIALIZAR TODOS LOS WIDGETS DISPONIBLES
     ========================================================= */

  function initAvailableCarousels() {

    const roots =
      document.querySelectorAll(
        ROOT_SELECTOR
      );


    if (!roots.length) {
      return false;
    }


    let ready =
      true;


    roots.forEach(
      (root) => {

        if (
          !initCarousel(root)
        ) {
          ready = false;
        }

      }
    );


    return ready;

  }


  /* =========================================================
     ESPERAR A JUDGE.ME

     NO utilizamos un MutationObserver global.

     Hacemos una comprobación pequeña cada 250ms
     y dejamos de hacerlo automáticamente.
     ========================================================= */

  function waitForJudgeMe() {

    if (
      initAvailableCarousels()
    ) {
      return;
    }


    let elapsed =
      0;


    const timer =
      window.setInterval(
        () => {

          elapsed +=
            WAIT_INTERVAL;


          if (
            initAvailableCarousels() ||
            elapsed >= WAIT_TIMEOUT
          ) {

            window.clearInterval(
              timer
            );

          }

        },
        WAIT_INTERVAL
      );

  }


  /* =========================================================
     ARRANQUE
     ========================================================= */

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      waitForJudgeMe,
      {
        once: true
      }
    );

  } else {

    waitForJudgeMe();

  }


  /* =========================================================
     EDITOR DE SHOPIFY
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    () => {

      window.setTimeout(
        waitForJudgeMe,
        100
      );

    }
  );

})();